<style scoped>
#tootip {
  position: absolute;
  background: rgba(28, 95, 112, 0.8);
  border: 1px solid #16d0fe;
  border-radius: 10px;
  box-shadow: 0 0 8px #16d0fe;
  transition: all 0.01s;
  box-sizing: border-box;
  transform: translate(-10px, -110%);
  padding: 10px;
  visibility: hidden;
}
</style>
<template>
  <div style="position: relative; flex: 1;">
    <svg id="map" ref="mapbox" @dblclick="svgClick"></svg>
    <div id="tootip"></div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
// import china from '@/assets/js/china';
// import mapprojection from '@/assets/js/mapprojection';
import * as d3 from 'd3';
export default {
  name: 'mapbox',
  props: {
    rptList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mapdata: {},
      mapprojection: {},
      datalist: this.sort(this.rptList),
      level: 0,
      timer: null
    };
  },
  watch: {
    rptList(val) {
      this.datalist = this.sort(val);
      this.mapdata.name && this.render(this.mapdata);
    }
  },
  created() {
    let mapprojection = this.$axios(`./json/mapprojection.json`);
    let china = this.$axios(`./json/100000.json`);
    Promise.all([china, mapprojection]).then(res => {
      this.mapdata = res[0].data;
      this.mapprojection = res[1].data;
      this.render(this.mapdata);
    });
    window.addEventListener('resize', this.onresize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onresize);
  },
  methods: {
    onresize() {
      this.render(this.mapdata);
    },
    svgClick(e) {
      if (e.target.id == 'map') {
        request({ url: `/api/rpt/area?level=0` }).then(res => {
          this.$axios(`./json/100000.json`).then(map => {
            const tip = d3.select('#tootip');
            tip && tip.style('visibility', 'hidden');
            this.mapdata = map.data;
            this.datalist = this.sort(res.result);
            this.level = 0;
            this.render(this.mapdata);
          });
        });
      }
    },
    render(coord) {
      this.timer && clearInterval(this.timer);
      let coordData = coord || this.mapdata;
      const colors = ['#660208', '#cc2929', '#ff7b69'];
      const width = this.$refs.mapbox.clientWidth;
      const height = this.$refs.mapbox.clientHeight;
      // 定义地图的投影
      const projection = d3.geoMercator().fitSize([width, height], coordData);

      // 定义地理路径生成器
      const path = d3.geoPath().projection(projection);

      // 绘制svg
      const svg = d3.select('#map');

      // 清除画布
      svg.selectAll('g').remove();

      // 提示模块
      const tip = d3.select('#tootip');

      svg
        .append('g')
        .style('transform', 'translate(8px, 4px)')
        .selectAll('path')
        .data(coordData.name == '100000_full' ? this.mapprojection.features : coordData.features)
        .enter()
        .append('path')
        .attr('stroke', 'rgba(17,69,102,0.8)')
        .attr('fill', '#0c1948')
        .attr('d', path);

      // 绘制元素容器
      const g = svg.append('g');
      // 地图路径绘制
      g.selectAll('path')
        .data(coordData.features)
        .enter()
        .append('path')
        .attr('class', data => {
          return `city${data.properties.adcode} province`;
        })
        .style('fill', data => {
          let code = data.properties.adcode;
          for (let i = 0; i < this.datalist.length; i++) {
            if (code == this.datalist[i].area_id) {
              if (this.level === 0) {
                // 设置省级top5  top10  top15颜色
                if (i < 5) {
                  return colors[0];
                } else if (i >= 5 && i < 10) {
                  return colors[1];
                } else if (i >= 10 && i < 15) {
                  return colors[2];
                }
              } else {
                if (i == 0) {
                  return colors[0];
                } else if (i == 1) {
                  return colors[1];
                } else if (i == 2) {
                  return colors[2];
                }
              }
            }
          }
          return '#0c1948';
        })
        .style('stroke', '#017bc9')
        .attr('d', path)
        .on('mouseover', data => {
          this.timer && clearInterval(this.timer);
          document.querySelector('.province.active') && document.querySelector('.province.active').classList.remove('active');
          let { offsetX, offsetY } = d3.event;
          if (offsetX < 0) offsetX = 0;
          tip
            .style('visibility', 'visible')
            .style('left', `${offsetX}px`)
            .style('top', `${offsetY}px`)
            .html(this.tipHtml(data.properties.adcode, data.properties.name));
        })
        .on('mousemove', () => {
          this.timer && clearInterval(this.timer);
          let { offsetX, offsetY } = d3.event;
          if (offsetX < 0) offsetX = 0;
          tip.style('left', `${offsetX}px`).style('top', `${offsetY}px`);
        })
        .on('mouseout', () => {
          this.interval(projection);
          tip.style('visibility', 'hidden');
        })
        .on('dblclick', async data => {
          if (this.level < 3) {
            this.level = this.level + 1;
            let mapdata = await this.$axios(`./json/${data.properties.adcode}.json`);
            let listres = await request({ url: `/api/rpt/area?id=${data.properties.adcode}&level=${this.level}` });
            this.mapdata = mapdata.data;
            this.datalist = this.sort(listres.result);
            this.render(this.mapdata);
          }
        });

      this.interval(projection);
    },

    // 排序
    sort(arr) {
      var len = arr.length;
      for (var i = 0; i < len - 1; i++) {
        for (var j = 0; j < len - 1 - i; j++) {
          if (arr[j].total_ysx_amt < arr[j + 1].total_ysx_amt) {
            // 相邻元素两两对比
            var temp = arr[j + 1]; // 元素交换
            arr[j + 1] = arr[j];
            arr[j] = temp;
          }
        }
      }
      return arr;
    },

    // 定时亮起
    interval(projection) {
      // 定时亮起
      let i = 0;
      let len = this.datalist.length;
      let mapdata = this.mapdata.features;
      this.timer = setInterval(() => {
        if (i < len) {
          document.querySelector('.province.active') && document.querySelector('.province.active').classList.remove('active');
          for (let x = 0; x < mapdata.length; x++) {
            if (this.datalist[i].area_id == mapdata[x].properties.adcode) {
              document.querySelector(`.city${this.datalist[i].area_id}`) &&
                document.querySelector(`.city${this.datalist[i].area_id}`).classList.add('active');

              const site = projection(mapdata[x].properties.center);
              // 提示模块
              const tip = d3.select('#tootip');
              tip
                .style('visibility', 'visible')
                .style('left', `${site[0]}px`)
                .style('top', `${site[1]}px`)
                .html(this.tipHtml(mapdata[x].properties.adcode, mapdata[x].properties.name));
            }
          }

          i++;
        } else {
          i = 0;
        }
      }, 3000);
    },
    // 提示html
    tipHtml(adcode, name) {
      let html = '';
      for (let i = 0; i < this.datalist.length; i++) {
        if (this.datalist[i].area_id == adcode) {
          html = `<div class="tootip-title">${this.datalist[i].area_name || name || ''}</div>
                  <div class="tootip-content-item">当日预授信：<span>${this.datalist[i].curr_day_ysx_amt}</span></div>
                  <div class="tootip-content-item">当周预授信：<span>${this.datalist[i].curr_week_ysx_amt}</span></div>
                  <div class="tootip-content-item">当月预授信：<span>${this.datalist[i].curr_mon_ysx_amt}</span></div>
                  <div class="tootip-content-item">预授信总额(万元)：<span>${this.datalist[i].total_ysx_amt}</span></div>
                  <div class="tootip-content-item">预授信企业数(家)：<span>${this.datalist[i].total_ysx_company}</span></div>`;
          break;
        } else {
          html = `<div class="tootip-title">${name}</div>
                  <div class="tootip-content-item">当日预授信：<span>0</span></div>
                  <div class="tootip-content-item">当周预授信：<span>0</span></div>
                  <div class="tootip-content-item">当月预授信：<span>0</span></div>
                  <div class="tootip-content-item">预授信总额(万元)：<span>0</span></div>
                  <div class="tootip-content-item">预授信企业数(家)：<span>0</span></div>`;
        }
      }
      return html;
    }
  }
};

// const colorConfig = {
//   '#660208': [10000],
//   '#8c0d0d': [1000, 9999],
//   '#cc2929': [100, 999],
//   '#ff7b69': [10, 99],
//   '#ffaa85': [1, 9],
//   '#f5f5f5': [0]
// };
// const data = {
//   350000: 9999
// };

// g.selectAll('text')
//   .data(china.features)
//   .enter()
//   .append('text')
//   .attr('transform', d => {
//     if (d.properties.centroid || d.properties.center) {
//       const coor = projection(d.properties.centroid || d.properties.center);
//       return `translate(${coor[0]}, ${coor[1]})`;
//     } else {
//       return `translate(0, 0)`;
//     }
//   })
//   .text(d => {
//     return d.properties.name;
//   })
//   .attr('text-anchor', 'middle')
//   .style('font-size', '9px')
//   .attr('fill', 'rgba(255,255,255,0.6)');

// 缩放
// const zoom = d3
//   .zoom()
//   .scaleExtent([1, 3]) //设置监听范围
//   .on('zoom', zoomed); //设置监听事件
// function zoomed() {
//   const t = d3.event.transform;
//   g.attr('transform', `translate(${t.x}, ${t.y}) scale(${t.k})`);
// }
// svg.call(zoom); //应用
// g.selectAll('path').on('click', () => {
//   console.log(d3.event);
// });

// let i = 0;
</script>
